import { getPlainTextLengthFromHtml } from '@talentmesh/rte';
import { AutocompleteOption } from '@talentmesh/ui/components/autocomplete-chips';
import { JobAdSkillsDTO } from './JobAdSkillsDTO';
import { DefaultJobAdDetailsDTO, JobAdDetailsDTO } from './JobDetailsDTO';
import { AssessmentStatuses } from '@/Models/AssessmentData';
import JobAdSkillsType from '@/Models/JobAdSkillsType';
import { JobAd } from '@/Pages/Assessments/Modify/Models/JobAd';

export interface JobAdDTO {
    recruitmentId: string;
    clientId: string;
    status: AssessmentStatuses;
    jobDetails: JobAdDetailsDTO;
    jobAdTitle: string;
    skills: JobAdSkillsDTO[];
    jobAdDescription: string;
    companyDescription: string;
}

export const DefaultJobAdDTO: JobAdDTO = {
    recruitmentId: '',
    clientId: '',
    status: AssessmentStatuses.Active,
    jobDetails: DefaultJobAdDetailsDTO,
    jobAdTitle: '',
    skills: [],
    jobAdDescription: '',
    companyDescription: '',
};

export function mapJobAdDTO2Model(dto: JobAdDTO): JobAd {
    const hardSkills = dto.skills
        .filter((x) => x.skillType === JobAdSkillsType.HardSkill)
        .map<AutocompleteOption>((x) =>
            x.id === undefined || x.id === null ? { label: x.skillName } : { id: String(x.id), label: x.skillName },
        );
    const softSkills = dto.skills
        .filter((x) => x.skillType === JobAdSkillsType.SoftSkill)
        .map<AutocompleteOption>((x) =>
            x.id === undefined || x.id === null ? { label: x.skillName } : { id: String(x.id), label: x.skillName },
        );

    const descriptionLen = getPlainTextLengthFromHtml(dto.jobAdDescription);

    return {
        title: dto.jobAdTitle,
        description: dto.jobAdDescription,
        descriptionLen,
        hardSkills,
        hardSkillsSwitch: hardSkills.length > 0,
        softSkills,
        softSkillsSwitch: softSkills.length > 0,
        status: dto.status,
        companyDescription: dto.companyDescription,
    };
}
